// ponytail: flip to 'phone' to promote phone sign-in to primary — see T22.3 (adr-0031).
export const PRIMARY_LOGIN_METHOD = 'email';
/** Returns sign-in methods ordered with the primary first. */
export function getLoginMethods(primary = PRIMARY_LOGIN_METHOD) {
    return primary === 'email' ? ['email', 'phone'] : ['phone', 'email'];
}
//# sourceMappingURL=auth-config.js.map